import { getMessageFactory } from "../getCaxaWebSocket.js";
const highlightPid = getMessageFactory({
  code: "HIGHLIGHT_PID"
});
export { highlightPid };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/highlightPid.js